import { Icon } from '@natera/material/lib/icon'
import { cn } from '~/shared/lib/cn'
import { Button, LocalIcon, Text } from '~/shared/ui'
import type { UploadItem } from '../../model/types'
import { useUploadQueueStore } from '../../model/use-upload-queue-store'

interface UploadProgressRowProps {
  item: UploadItem
}

export function UploadProgressRow({ item }: UploadProgressRowProps): React.ReactElement {
  const handleRetry = (): void => {
    useUploadQueueStore.getState().retry(item.id)
  }

  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <div className="flex flex-1 items-center gap-2">
        <div
          className={cn(
            'bg-surface-medium text-content-high-emphasis flex size-[26px] shrink-0 items-center justify-center rounded-full',
            {
              'bg-alert-success-fill text-success-content': item.status === 'success',
              'bg-alert-error-fill text-alert-error-content': item.status === 'failed',
            },
          )}
        >
          <LocalIcon
            name="orderOutlined"
            size="18"
          />
        </div>
        <div className="flex flex-col">
          <Text
            appearance="BODY2"
            className="text-text-primary line-clamp-1 break-all"
          >
            {item.file.name}
          </Text>
          {item.status === 'failed' && (
            <Text
              appearance="CAPTION"
              className="text-alert-error-message"
            >
              Upload fails
            </Text>
          )}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {(item.status === 'pending' || item.status === 'uploading') && (
          <span
            className="mr-0.5 inline-block size-4 animate-spin rounded-full"
            style={{
              background:
                'conic-gradient(from 0deg, transparent 0deg, var(--color-content-medium-emphasis) 270deg, transparent 360deg)',
              WebkitMask:
                'radial-gradient(circle, transparent calc(50% + 1px), #000 calc(50% + 1px))',
              mask: 'radial-gradient(circle, transparent calc(50% + 1px), #000 calc(50% + 1px))',
              animationDuration: '1.2s',
            }}
          />
        )}
        {item.status === 'success' && (
          <Icon
            className="text-success-content text-[20px]"
            children="check_circle"
            fill
          />
        )}
        {item.status === 'failed' && (
          <Button
            size="small"
            onClick={handleRetry}
          >
            Try again
          </Button>
        )}
      </div>
    </div>
  )
}
